import React, { useEffect, useRef, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Select, Table } from "antd";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import svg15 from "../../../assets/svg/svg15.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import { fetchData } from "../../../features/fetch/fetchSlice";
import moment from "moment";
import { setActiveObj } from "../../../features/obj/objSlice";
import svg36 from "../../../assets/svg/svg36.svg";
import BgHeader from "../BgHeader";
import LeafletMap from "./LeafletMap";

function LandingSchemes() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const formRef = useRef(null);

  const urlSchCard = "";
  const url = "sch/get_schemes";
  const urlPathway = "api/v2/irrigationPathway/get";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const { refetchKey } = useSelector((state) => state.global);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const [selectId, setSelectId] = useState("PUBLIC");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        schName: e.target.value == "" ? null : e.target.value,
        limit: null,
        start: 0,
      })
    );
  };
  const truncateText = (text, maxLength) => {
    if (text?.length > maxLength) {
      return text?.substring(0, maxLength - 3) + "...";
    }
    return text;
  };

  const handleEdit = async () => {
    await dispatch(
      setActiveObj({
        key:
          selectId === "PUBLIC"
            ? "schemes"
            : selectId === "PRIVATE"
            ? "privateSchemes"
            : selectId === "COMMUNITY"
            ? "communitySchemes"
            : selectId === "ASAL"
            ? "asalSchemes"
            : null,
        data: prodd,
      })
    );
    await navigate(
      selectId === "PUBLIC"
        ? "/scheme/public-scheme-view"
        : selectId === "PRIVATE"
        ? "/scheme/private-scheme-view"
        : selectId === "COMMUNITY"
        ? "/scheme/community-scheme-view"
        : selectId === "ASAL"
        ? "/scheme/asal-scheme-view"
        : null
    );
  };

  const handleView = async (item) => {
    await dispatch(
      fetchData({
        url: urlSchCard,
        schId: item?.schId,
        limit: null,
        start: 0,
      })
    );
    await navigate(
      selectId === "PUBLIC"
        ? "/scheme/public-scheme-view"
        : selectId === "PRIVATE"
        ? "/scheme/private-scheme-view"
        : selectId === "COMMUNITY"
        ? "/scheme/community-scheme-view"
        : selectId === "ASAL"
        ? "/scheme/asal-scheme-view"
        : null
    );
    await dispatch(
      setActiveObj({
        key:
          selectId === "PUBLIC"
            ? "schemes"
            : selectId === "PRIVATE"
            ? "privateSchemes"
            : selectId === "COMMUNITY"
            ? "communitySchemes"
            : selectId === "ASAL"
            ? "asalSchemes"
            : null,
        data: item,
      })
    );
  };
  const handleViewName = async (item) => {
    await dispatch(
      fetchData({
        url: urlSchCard,
        schId: item?.schId,
        limit: null,
        start: 0,
      })
    );
    await navigate(
      selectId === "PUBLIC"
        ? "/scheme/public-scheme-view"
        : selectId === "PRIVATE"
        ? "/scheme/private-scheme-view"
        : selectId === "COMMUNITY"
        ? "/scheme/community-scheme-view"
        : selectId === "ASAL"
        ? "/scheme/asal-scheme-view"
        : null
    );
    await dispatch(
      setActiveObj({
        key:
          selectId === "PUBLIC"
            ? "schemes"
            : selectId === "PRIVATE"
            ? "privateSchemes"
            : selectId === "COMMUNITY"
            ? "communitySchemes"
            : selectId === "ASAL"
            ? "asalSchemes"
            : null,
        data: item,
      })
    );
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div
        //  onClick={handleOpenDelete}
        >
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <span className="whitespace-nowrap">PDF</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },

    {
      key: "2",
      label: (
        <div
        //  onClick={handleOpenDelete}
        >
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <span className="whitespace-nowrap">Excel</span>
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Project",
      render: (item) => {
        return <div className="cursor-pointer">{item?.schName}</div>;
      },
      sorter: (a, b) => a.schName.localeCompare(b.schName),
    },
    {
      title: "Scheme Type",
      dataIndex: "schSchemeType",
      sorter: (a, b) => a.schSchemeType.localeCompare(b.schSchemeType),
    },

    {
      title: "Farm Size",
      dataIndex: "schLandSize",
      sorter: (a, b) => a.schLandSize.localeCompare(b.schLandSize),
    },
    {
      title: "Household No.",
      dataIndex: "schHouseholdNo",
      sorter: (a, b) => a.schHouseholdNo.localeCompare(b.schHouseholdNo),
    },

    {
      title: "Water Source",
      dataIndex: "schWaterSource",
      sorter: (a, b) => a.schWaterSource.localeCompare(b.schWaterSource),
    },

    {
      title: "Start Date",
      dataIndex: "schCreatedDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.schCreatedDate).valueOf() - moment(b.schCreatedDate).valueOf(),
    },

    // {
    //   title: "Actions",
    //   render: (item) => (
    //     <>
    //       <button onClick={() => handleView(item)}>
    //         <img src={svg15} alt="svg15" />
    //       </button>
    //     </>
    //   ),
    // },
  ];

  const [activeBtn, setActiveBtn] = useState(null);

  const handleClick = async (item) => {
    await setActiveBtn(item);
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchSchemeData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        schName: null,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchSchemeData();
  }, []);

  // useEffect(() => {
  //   // dispatch(fetchCrops());
  //   // dispatch(fetchWaterSources());
  //   // dispatch(fetchIrrigationType());
  //   // dispatch(fetchCounties());
  //   // dispatch(fetchMemberTypes());

  //   // dispatch(fetchFundingMode());
  //   // dispatch(fetchWtrConvMeans());
  //   // dispatch(fetchWtrApplMode());
  //   // dispatch(fetchWtrAbstraction());
  //   // fetchAgencyData();
  //   // fetchFundingSrcData();
  //   // dispatch(
  //   //   fetchData({
  //   //     url: urlPathway,
  //   //     limit: null,
  //   //     start: 0,
  //   //   })
  //   // );
  // }, []);

  if (loading && !searchInput)
    return (
      <div className="mt-[15rem] w-full text-center flex items-center justify-center">
        <CardLoading />
      </div>
    );
  return (
    <>
      <div className=" w-full bg-[#F7F7F7]" id="landing-schemes">
        <BgHeader title="Schemes" />
        <div className="flex lg:flex-row flex-col gap-x-[3.65rem] gap-y-[1.25rem] px-[1.25rem] lg:pt-[3.75rem] pt-[1.75rem]">
          <div className="flex flex-col">
            <span className="text-[#050505] text-[1.125rem] font-sora font-[400]">
              ALL Schemes
            </span>

            <div className="flex lg:flex-col flex-row items-start gap-[.43rem]  w-auto lg:p-1.5">
              <button
                onClick={() => handleClick(null)}
                className={`${
                  activeBtn === null ? "text-[#1A1A1A] bg-[#F1F3F5] " : ""
                }flex items-start  font-[400] font-sora text-[.875rem] rounded-[.3125rem] py-[.5rem] px-[1rem] `}
              >
                All
              </button>
              <button
                onClick={() => handleClick("PUBLIC")}
                className={`${
                  activeBtn === "PUBLIC" ? "text-[#1A1A1A] bg-[#F1F3F5] " : ""
                }flex items-start  font-[400] font-sora text-[.875rem] rounded-[.3125rem] py-[.5rem] px-[1rem] `}
              >
                Public
              </button>

              <button
                onClick={() => handleClick("COMMUNITY")}
                className={`${
                  activeBtn === "COMMUNITY"
                    ? "text-[#1A1A1A] bg-[#F1F3F5] "
                    : ""
                }flex items-start  font-[400] font-sora text-[.875rem] rounded-[.3125rem] py-[.5rem] px-[1rem] `}
              >
                Community
              </button>
              <button
                onClick={() => handleClick("PRIVATE")}
                className={`${
                  activeBtn === "PRIVATE" ? "text-[#1A1A1A] bg-[#F1F3F5] " : ""
                }flex items-start  font-[400] font-sora text-[.875rem] rounded-[.3125rem] py-[.5rem] px-[1rem] `}
              >
                Private
              </button>
            </div>
          </div>
          <div className="w-full flex flex-col">
            <div className="flex items-center justify-between w-full">
              <div className="lg:w-[29.1875rem] w-auto">
                <Search
                  searchInput={searchInput}
                  handleSearch={handleSearch}
                  text={"Search ..."}
                />
              </div>
              <Dropdown
                overlayStyle={{
                  width: "150px",
                }}
                trigger={"click"}
                menu={{ items: settingItems }}
                placement="bottom"
              >
                <button
                  className="rounded-[.375rem] border border-[#D6E1F5] px-[.75rem] py-[.5rem] flex  bg-white
              text-[#1A1A1A] text-[.875rem] font-[400] gap-[.5rem] items-center"
                  // onClick={() => setProdd(item)}
                >
                  Export
                  <img src={svg36} alt="svg36" />
                </button>
              </Dropdown>
            </div>
            <Table
              rowSelection={false}
              className="mt-[1.31rem]"
              scroll={{
                x: "auto",
              }}
              rowKey={(record) => record?.schId}
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                position: ["bottomRight"],
                current: pageIndex + 1,
                total: count,
                pageSize: pageSize,
                onChange: (page, size) => {
                  setPageIndex(page - 1);
                  setPageSize(size);
                  fetchSchemeData(page - 1, size);
                },
                showSizeChanger: false,
                hideOnSinglePage: true,
              }}
            />{" "}
          </div>
        </div>

        <div className="pt-[1.5rem] pb-[5.25rem]">
          <LeafletMap />
        </div>
      </div>
    </>
  );
}

export default LandingSchemes;
